import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-second-content',
  templateUrl: './second-content.component.html',
  styleUrls: ['./second-content.component.scss']
})
export class SecondContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
